import { render } from "./ModalUserDisabled.vue?vue&type=template&id=76c40daa"
import script from "./ModalUserDisabled.vue?vue&type=script&lang=js"
export * from "./ModalUserDisabled.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__